import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'ml' : 'en');
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: '10px',
        right: '100px',
        zIndex: 1100,
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <button
        type="button"
        onClick={toggleLanguage}
        style={{
          border: '1px solid #009688',
          borderRadius: '999px',
          background: '#fff',
          color: '#009688',
          padding: '6px 12px',
          cursor: 'pointer',
          fontSize: '14px',
          fontWeight: 600,
        }}
        aria-label="Switch language"
      >
        {language === 'en' ? 'മലയാളം' : 'English'}
      </button>
    </div>
  );
};

export default LanguageSwitcher;